module.exports = {
	"CD": {
		"title": "Andělové, Andělové",
		"info": {
			"cs-CZ": "Nahráno v letech 2013, 2015, a 2016. Celkový čas: 78:10 min.",
			"en-GB": "Recorded in 2013, 2015, and 2016. Total time: 78:10 min.",
			"fr-FR": "Enregistré en 2013, 2015, et 2016. Durée totale : 78:10 min.",
			"de-DE": "Aufgenommen in den Jahren 2013, 2015, 2016. Gesamtlänge: 78:10 Minuten."
		},
		"tracks": [
			{
				"title": "Andělové, andělové (Franusův kancionál, 1505) – ženská část",
				"time": "1:48"
			},
			{
				"title": "Velice chválí duše má Spasitele mého Boha (Prachatický kancionál, cca 1610)",
				"time": "5:50"
			},
			{
				"title": "Písnička příkladná (Dobřanský kancionál, cca 1570)",
				"time": "1:44"
			},
			{
				"title": "Adam Václav Michna: Druhá adventní - Rorate, coeli (Svatoroční muzika, č. 2)",
				"time": "2:54"
			},
			{
				"title": "Adam Václav Michna: Píseň adventní (Svatoroční muzika, č. 1)",
				"time": "3:18"
			},
			{
				"title": "Adam Václav Michna: O zvěstování blahoslavené Panny Marie - (Svatoroční muzika, č. 26)",
				"time": "3:25"
			},
			{
				"title": "Adam Václav Michna: Adama, prvního otce, pokání (Svatoroční muzika, č. 3)",
				"time": "3:42"
			},
			{
				"title": "Andělové, andělové (Franusův kancionál, 1505) – latinská část",
				"time": "1:11"
			},
			{
				"title": "Anjelé radost jměli (rukopis NUK Praha, 15. stol.)",
				"time": "3:09"
			},
			{
				"title": "Přišel nám den veselý (kancionál, Čechy, 14. stol.)",
				"time": "1:46"
			},
			{
				"title": "Radujme se, veselme se / Radujme se všichni věrní",
				"time": "3:00"
			},
			{
				"title": "In novo anno (Jistebnický kancionál, c.1420)",
				"time": "1:38"
			},
			{
				"title": "Nowe lato (anonym, 1556, text W. Basaeus z Szczebrzeszyna)",
				"time": "2:37"
			},
			{
				"title": "Adam Václav Michna: Vánoční hospoda (Česká mariánská muzika, č. 7)",
				"time": "3:52"
			},
			{
				"title": "Adam Václav Michna: Nebeský slavíček, k chvále Boží sladce prozpěvující, divné Boží narození (Svatoroční muzika, č. 6)",
				"time": "4:01"
			},
			{
				"title": "Adam Václav Michna: Vánoční noc (Česká mariánská muzika, č. 2)",
				"time": "3:46"
			},
			{
				"title": "Adam Václav Michna: Vánoční vinšovaná pošta (Česká mariánská muzika, č. 6)",
				"time": "2:38"
			},
			{
				"title": "Karel Václav Holan Rovenský: Usni, usni, ctné poupátko",
				"time": "2:45"
			},
			{
				"title": "Karel Václav Holan Rovenský: Spanilé z archy holubičky",
				"time": "3:38"
			},
			{
				"title": "Adam Václav Michna: Opět jiná o Narození Pána Krista (Svatoroční muzika, č. 9)",
				"time": "2:37"
			},
			{
				"title": "Adam Václav Michna - Jiná o Narození Pána Ježíše (Svatoroční muzika, č. 7)",
				"time": "2:49"
			},
			{
				"title": "Adam Václav Michna: O svatých třech králích (Svatoroční muzika, č. 16)",
				"time": "3:36"
			},
			{
				"title": "Adam Václav Michna: Zvaní všeho stvoření k slavnosti Nejsvětějšího Jména Ježíš (Svatoroční muzika, č.15)",
				"time": "5:37"
			},
			{
				"title": "Adam Václav Michna: Na Nové léto (Svatoroční muzika, č. 14)",
				"time": "3:06"
			},
			{
				"title": "Andělové, andělové (Franusův kancionál, 1505) – mužská část",
				"time": "3:25"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/post01/CD06.json
// module id = 83
// module chunks = 0